import { makeStyles } from "@material-ui/core/styles";
export default makeStyles((theme) => ({
  input: {
    "&.MuiInput-underline:before": {
      borderBottom: "0px",
    },
    ".&::placeholder": {
      fontStyle: "italic",
    },
    "&.makeStyles-amountInput-33.MuiInput-underline:before, .makeStyles-amountInput-33.MuiInput-underline:after, .makeStyles-amountInput-33.MuiInput-underline:hover, .makeStyles-amountInput-33.MuiInput-underline:hover:not(.Mui-disabled):before:hover":
      {
        borderBottom: "0px",
      },
  },
  textFieldFullWidth: {
    width: "100%",
  },
  amountLabel: {
    display: "flex",
    justifyContent: "space-between",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "14px",
    lineHeight: "18px",
    /* identical to box height */
    paddingTop: "20px",
    // paddingBottom:"5px"x,
    paddingLeft: "0.9375rem",
    /* Wireframe/Blue/Secondary */

    color: "#282828",
  },depositeButton:{
    padding: "10px 20px",
    borderRadius: "50px",
    fontWeight: "600",
    position: "static",
    left: "14.37%",
    right: "14.37%",
    top: "26%",
    width:"100%",
    bottom: "26%",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "24px",
    textAlign: "center",
    color: "#282828",
    // opacity: "0.8",
    flex: "none",
    order: "0",      
    textTransform: "capitalize",
    border:"2px solid #FFDF00",
    flexGrow: "0",
    // margin: "0px 10px",
    marginRight: "auto",
    "&.MuiButton-root:hover": {
      backgroundColor: "linear-gradient(0deg, rgba(220, 30, 30, 0.15), rgba(220, 30, 30, 0.55))",
    },
    "&.MuiButton-root": {
      TextTransform: "capitalize",
    },
    "@media (max-width:550px)": {
      padding: "6px 12px",
      // borderRadius: "12px",
      fontSize: "14px",
    },
  },
  errorButton:{
    background: "linear-gradient(0deg, rgba(220, 30, 30, 0.15), rgba(220, 30, 30, 0.15))",
    border:"2px solid #DC1E1E",
    color:"#282828",
    "&.MuiButton-root:disabled": {
      color:"#282828",
    },
  },emptyAmount:{
    background:"linear-gradient(0deg, rgba(73, 73, 73, 0.35), rgba(73, 73, 73, 0.35))",
    border:"2px solid #bfbfbf",
    borderRadius: "100px",
    "&:disabled":{
      background: "#bfbfbf",
      color:"#fff"
    }
  },
    normalButton:{
      background:"#FFDF00",
      "&.MuiButton-root:hover": {
        backgroundColor: "#f7d905",
      },
      // "&.MuiButton-root:hover": {
      //   background: "linear-gradient(0deg, rgba(220, 30, 30, 0.15), rgba(220, 30, 30, 0.55))",
      //   backgroundColor: "#f7d905",
      //   boxShadow:"0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
      // },
    },
  amountInput: {
    width: "100%",
    fontSize: "18px",
    background: "#FAFAFA",
    border: "1px solid rgba(0, 0, 0, 0.04)",
    alignItems: "center",
    padding: "15px 20px",

    position: "static",
    width: "100%",
    height: "65px",
    left: "0px",
    top: "28px",
    fontSize: "1.325em",
    background: "#FAFAFA",
    boxSizing: "border-box",
    borderRadius: "100px",

    /* Inside Auto Layout */

    flex: "none",
    order: "1",
    alignSelf: "stretch",
    flexGrow: "0",
    margin: "10px 0px",
    // "&.MuiInput-underline:before ,&.MuiInput-underline:after,&.MuiInput-underline:hover,&.MuiInput-underline:hover:not(.Mui-disabled):before":
    //   {
    //     borderBottom: "none",
    //   },
    "&.MuiInputBase-input": {
      paddingInline: "10px",
    },
  },
  maxButton: {
    background: "#FFDF00",
    fontSize: "13px",
    borderRadius: "50px",
    justifyContent: "center",
    cursor: "pointer",
    alignItems: "center",
    padding: "2px 15px",
    fontWeight: "600",
    position: "static",
    width: "28px",
    // height: "26px",
    left: "301px",
    top: "0px",
    color: " #282828",
    lineHeight: "24px",
    letterSpacing: "1px",
    background: " #FFDF00",
    borderRadius: "50px",
    "&.MuiButton-root:hover": {
      backgroundColor: "#f7d905",
    },
  },
  swapToken: {
    marginTop: "10px",
    display: "flex",
    alignItems: "center",
    padding: "15px 20px",

    // width: "199.68px",
    // height: "65px",
    left: "0px",
    top: "28px",

    background: "#FAFAFA",
    border: " 1px solid rgba(0, 0, 0, 0.04)",
    boxSizing: " border-box",
    borderRadius: "50px",
  },
  swapLabel: {
    paddingLeft: "0.9375rem",
  },
  swapIcon: {
    display: "flex",
    border: " 1px solid rgba(0, 0, 0, 0.04)",
    alignItems: "center",
    marginTop: "54px",
    // padding: "15px",
    marginInline: "10px",
    // background: "#FAFAFA",
    borderRadius: "50px",
    marginBottom: "8px",
  },
  width100: {
    width: "100%",
  },
  tokenLabel: {
    paddingLeft: "10px",
    fontWeight: "600",
    fontSize: "18px",
    lineHeight: "23px",
    color: "#282828",
  },
  tokenLogo: {
    alignItems: "center",
    display: "flex",
  },
}));
